import React from 'react';
/**
 * Renders the Details column as a single truncated line (IIM IssuesGrid pattern).
 * Full text is available on the `title` tooltip. Keep independent of DeficienciesIndex.
 *
 * - When assetDetails has entries: "label: value · label: value"
 * - When assetDetails is empty: the `details` fallback string
 */
export function DeficiencyDetailsCell({ item, compact = false }) {
    var _a;
    const entries = Object.entries(item.assetDetails);
    const text = entries.length === 0
        ? (_a = item.details) !== null && _a !== void 0 ? _a : ''
        : entries.map(([key, value]) => `${key}: ${value}`).join(' · ');
    return (React.createElement("span", { className: compact ? 'deficiencies-table__details deficiencies-table__details--compact' : 'deficiencies-table__details', title: text }, text));
}
